import { render, staticRenderFns } from "./resource-manage.vue?vue&type=template&id=a1e1b80c&scoped=true"
import script from "./resource-manage.vue?vue&type=script&lang=ts"
export * from "./resource-manage.vue?vue&type=script&lang=ts"
import style0 from "./resource-manage.vue?vue&type=style&index=0&id=a1e1b80c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e1b80c",
  null
  
)

export default component.exports